"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateToHTMLOptions = exports.emojis = void 0;
var stateToHTMLOptions = {
  entityStyleFn: function entityStyleFn(entity) {
    var entityType = entity.getType().toLowerCase();
    if (entityType === 'link') {
      var data = entity.getData();
      return {
        element: 'a',
        attributes: {
          href: data.url,
          target: '_blank' // Force all links to open in a new tab
        }
      };
    }

    return entity;
  }
};
exports.stateToHTMLOptions = stateToHTMLOptions;
var emojis = ['😀', '😁', '😂', '😃', '😉', '😋', '😎', '😍', '😗', '🤗', '🤔', '😣', '😫', '😴', '😌', '🤓', '😛', '😜', '😠', '😇', '😷', '😈', '👻', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '🙈', '🙉', '🙊', '👼', '👮', '🕵', '💂', '👳', '🎅', '👸', '👰', '👲', '🙍', '🙇', '🚶', '🏃', '💃', '⛷', '🏂', '🏌', '🏄', '🚣', '🏊', '⛹', '🏋', '🚴', '👫', '💪', '👈', '👉', '👆', '👇', '🖖', '🤘', '🖐', '👌', '👍', '👎', '✊', '👊', '👏', '🙌', '🙏', '🐵', '🐶', '🐇', '🐥', '🐸', '🐌', '🐛', '🐜', '🐝', '🍉', '🍄', '🍔', '🍤', '🍨', '🍪', '🎂', '🍰', '🍾', '🍷', '🍸', '🍺', '🌍', '🚑', '⏰', '🌙', '🌝', '🌞', '⭐', '🌟', '🌠', '🌨', '🌩', '⛄', '🔥', '🎄', '🎈', '🎉', '🎊', '🎁', '🎗', '🏀', '🏈', '🎲', '🔇', '🔈', '📣', '🔔', '🎵', '🎷', '💰', '🖊', '📅', '✅', '❎', '💯'];
exports.emojis = emojis;